<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.354 4.78095L4.92935 12.2056C3.17199 13.9629 3.17199 16.8122 4.92935 18.5695C6.68669 20.3269 9.53594 20.3269 11.2933 18.5695L20.1321 9.7307C21.3037 8.55915 21.3037 6.65965 20.1321 5.48805C18.9606 4.31648 17.0611 4.31648 15.8895 5.48805L7.05069 14.3269C6.46489 14.9127 6.46489 15.8624 7.05069 16.4482C7.63644 17.034 8.58619 17.034 9.17199 16.4482L16.5966 9.0236"
      stroke="#696D69"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
